import IntegerInput from "../IntegerInput";
import React from "react";
import {Controller, FieldPath} from "react-hook-form";
import {FieldValues} from "react-hook-form/dist/types/fields";
import {Control} from "react-hook-form/dist/types";

interface IntegerInputExProps<TFieldValues extends FieldValues> {
    control: Control<TFieldValues>,
    name: FieldPath<TFieldValues>,
    label?: string,
    disabled?: boolean,
    min: number,
    max: number,
}

export function IntegerInputEx<V extends FieldValues>(props: IntegerInputExProps<V>) {
    const {control, name, label, disabled, min, max} = props;
    let rules: { required?: boolean | string, valueAsNumber: boolean, max?: any, min?: any } = {valueAsNumber: true};
    if (typeof min !== "undefined")
        rules.min = min;
    if (max)
        rules.max = max;
    return (
        <Controller name={name}
                    control={control}
            /*defaultValue={0}*/
                    rules={{
                        validate: {
                            minNumber: (value) => parseFloat(value) >= min,
                            maxNumber: (value) => parseFloat(value) <= max
                        }
                    }}
                    render={({field: {value, onChange}, fieldState}) => {
                        return <>
                            <IntegerInput className="text-sm" label={label}
                                          value={value}
                                          disabled={disabled}
                                          setValue={(val) => onChange(isNaN(val) ? '' : val)}
                                          valueMin={min}
                                          valueMax={max}
                            />
                            {fieldState.error &&
                                <span className="text-rose-700">
                                    {fieldState.error.type === "minNumber" && (<p>Il numero dev'essere maggiore o uguale a {min}.</p>)}
                                    {fieldState.error.type === "maxNumber" && (<p>Il numero dev'essere minore o uguale a {max}.</p>)}
                                </span>
                            }
                        </>
                    }}
        />
    )
}

// Per la validazione vedi:
//https://codesandbox.io/s/react-hook-form-custom-validation-8kuu7?file=/src/index.js:1656-1880